// Side by side needs 512px form + 732px promo + gap + page padding; 1400px leaves no room for margins
export const SIDE_BY_SIDE = '@media (min-width: 1440px)'

export const PAGE_PADDING_X = 'clamp(24px, 4vw, 64px)'
export const PAGE_PADDING_Y = 'clamp(24px, 6vh, 64px)'

export const PROMO_WIDTH = 732
export const PROMO_MAX_HEIGHT = 896
export const PROMO_MIN_HEIGHT = 680
